export default function AlertsTableController($uibModal, $filter) {
  'ngInject';

  let vm = this;

  vm.orderAlertsCol = orderAlertsCol;
  vm.open = open;
  vm.pageChanged = pageChanged;
  vm.applyFilter = applyFilter;
  vm.calluUpdateAlert = calluUpdateAlert;

  vm.reverse = true;
  vm.filteredAlerts = [];
  vm.displayAssetLink = true;

  let orderBy = $filter('orderBy');

  //Pagination
  vm.maxSize = 1;
  vm.current = {
    alertPage: 1,
  };
  vm.itemsPerPage = 8;

  vm.$onInit = () => {
    if (window.location.href.includes('/assets/detail/')) {
      vm.displayAssetLink = false;
    }
  };

  vm.$onChanges = function (event) {
    if (event.alerts) {
      vm.alerts = event.alerts.currentValue;
      applyFilter();
    } else if (event.search) {
      if (event.search.text) {
        vm.search = event.search.currentValue;
        applyFilter();
      }
    } else if (event.loading) {
      vm.loading = event.loading.currentValue;
    }
  };

  const addToDataLayer = (data) => window.dataLayer.push(data);

  function calluUpdateAlert(state, singleAlert) {
    vm.updateAlert({
      state: state,
      singleAlert: singleAlert,
    });
    displayAlertsByPage();
  }

  //Calls displayALertsByPage(), everytime the the user changes the page.
  function pageChanged() {
    displayAlertsByPage();
  }

  //applyFilter searchs the alerts[] for anything matching the search input.
  function applyFilter() {
    if (vm.alerts !== undefined) {
      vm.filteredAlerts = $filter('filter')(vm.alerts, vm.search.text);
      vm.changeFirstLoad();
      orderAlertsCol(vm.predicate, true);
    }
  }

  function displayAlertsByPage() {
    vm.totalItems = vm.filteredAlerts.length;
    let begin = (vm.current.alertPage - 1) * vm.itemsPerPage;
    let end = begin + vm.itemsPerPage;
    vm.alertsByPage = vm.filteredAlerts.slice(begin, end);
  }

  //Sort alerts in the html by clicking the header, has to use scope reverse
  function orderAlertsCol(predicate, onLoad) {
    if (!onLoad) {
      vm.reverse = vm.predicate === predicate ? !vm.reverse : false;

      addToDataLayer({
        event: 'alertsSorting',
        data: {
          sortBy: predicate,
          order: vm.reverse ? 'desc' : 'asc',
        },
      });
    }

    vm.predicate = predicate;
    vm.updatePredicate({
      predicate: vm.predicate,
    });
    angular.forEach(vm.filteredAlerts, function (alert) {
      alert[predicate] = alert[predicate];
    });
    if (predicate === 'priority') {
      // priority should not sort alphabetically ( e.g.; High, Low, Medium), so use custom sort
      vm.filteredAlerts.sort(function (a, b) {
        if (!vm.reverse) {
          return priorityCustomOrder(a) > priorityCustomOrder(b) ? 1 : -1;
        } else {
          return priorityCustomOrder(b) > priorityCustomOrder(a) ? 1 : -1;
        }
      });
    } else {
      // sort alphabetically
      vm.filteredAlerts = orderBy(vm.filteredAlerts, predicate, vm.reverse);
    }

    displayAlertsByPage();
  }

  //open a modal
  function open(alert) {
    let modalInstance = $uibModal.open({
      animation: true,
      template: require('./notes-modal/note.html'),
      controller: 'DashboardNotesModalController',
      size: 'md',
      windowClass: 'tr-alerts-note-modal-dismiss',
      resolve: {
        alert: function () {
          return alert;
        }, //optional, to pass any items to modal
      },
    });

    vm.addAlertsInteraction(alert, 'notes');
  }

  function priorityCustomOrder(alert) {
    switch (alert.priority) {
      case 'Low':
        return 1;
      case 'Medium':
        return 2;
      case 'High':
        return 3;
    }
    return -1;
  }
}
